import Admissions from './Admissions';

export default Admissions;
